<template>
  <a-modal v-model="modalVisible" :title="modalTitle" :width="660" :centered="true">
    <template slot="footer">
      <a-button v-if="showType=='add'||showType=='edit'" @click="modalVisible=false">取消</a-button>
      <a-button type="primary" @click="confirm">确认</a-button>
    </template>
    <a-form-model ref="modalForm" :model="formDatas" :rules="formRules" :label-col="{span:7}" :wrapper-col="{span:14}">
      <a-form-model-item label="设备名称" prop="devicename">
        <a-input v-model.trim="formDatas.devicename" :disabled="showType=='detail'" />
      </a-form-model-item>
      <a-form-model-item label="设备编号" prop="devicenum">
        <a-input v-model.trim="formDatas.devicenum" :disabled="showType=='detail'" />
      </a-form-model-item>
      <a-form-model-item label="设备型号" prop="terminaltype">
        <a-select v-model="formDatas.terminaltype" :disabled="showType=='detail'">
          <a-select-option v-for="(item, index) in terminaltypes" :key="index" :value="item.value">{{item.text}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="设备是否使用温度传感器" prop="temp_sensor">
        <a-select v-model="formDatas.temp_sensor" placeholder="">
          <a-select-option value="是">是</a-select-option>
          <a-select-option value="否">否</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="描述" prop="devicedecs">
        <a-input v-model.trim="formDatas.devicedecs" :disabled="showType=='detail'" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>
<script>
// import terminaltypes from '@/json/terminaltypes'
import { addDeviceInfo, modifyDeviceInfo } from 'A/ai.js'
export default {
  props: {
    visible: {
      default: false
    },
    showType: {
      default: 'add'
    },
    detailData: {
      default: null
    },
    terminaltypes: {
      default() {
        return []
      }
    }
  },
  data() {
    return {
      // terminaltypes,
      modalVisible: false,
      formDatas: {
        deviceinfoid: '',
        devicename: '',
        devicenum: '',
        terminaltype: '',
        devicedecs: '',
        //设备是否使用温度传感器
        temp_sensor:'否',
      },
      formRules: {
        devicename: [{required: true, message: '请输入设备名称'}],
        devicenum: [{required: true, message: '请输入设备编号'}],
      }
    }
  },
  computed: {
    modalTitle() {
      if(this.showType == 'add') {
        return '新增'
      }else if(this.showType == 'edit') {
        return '修改'
      }else if(this.showType == 'detail') {
        return '详情'
      }else {
        return '';
      }
    }
  },
  watch: {
    visible(val) {
      if(val) {
        this.modalVisible = true;
        this.initDetail();
      }
    },
    modalVisible(val) {
      if(!val) {
        this.resetDatas();
        this.$emit('update:visible', false);
      }
    }
  },
  created() {
    this.modalVisible = this.visible;
  },
  methods: {
    initDetail() {
      if(this.detailData && (this.showType == 'edit' || this.showType == 'detail')) {
        this.$nextTick(() => {
          for(let key in this.formDatas) {
            this.formDatas[key] = this.detailData[key]||'';
          }
        })
      }
    },
    resetDatas() {
      this.formDatas.liftpropertyid = '';
      this.$refs.modalForm.resetFields();
    },
    confirm() {
      if(this.showType == 'add' || this.showType == 'edit') {
        this.$refs.modalForm.validate(valid => {
          if(valid) {
            this.showLoading();
            let params = {
              ...this.formDatas
            };
            if(this.showType == 'add') {
              addDeviceInfo(params).then(res => {
                this.hideLoading();
                if(res && res.returncode == '0') {
                  this.$message.success('操作成功');
                  this.$emit('get-operation-result', 'success', '操作成功');
                  this.modalVisible = false;
                }else {
                  this.$message.error(res.errormsg||'操作失败');
                }
              })
            }else {
              modifyDeviceInfo(params).then(res => {
                this.hideLoading();
                if(res && res.returncode == '0') {
                  this.$message.success('操作成功');
                  this.$emit('get-operation-result', 'success', '操作成功');
                  this.modalVisible = false;
                }else {
                  this.$message.error(res.errormsg||'操作失败');
                }
              })
            }
          }else {
            return false;
          }
        })
      }else {
        this.modalVisible = false;
      }
    }
  }
}
</script>